import { MutationTree } from 'vuex';
import { SortType } from '@/models/SortType';
import { CreateDirectPayload, getInitialState, PreavisInterventionState } from './state';
import { PREAVIS } from './mutation-types';
import { PreavisInterventionDTO } from '@/models/PreavisIntervention/PreavisInterventionDTO';
import { Site } from '@/models/Site';

export const mutations: MutationTree<PreavisInterventionState> = {
    [PREAVIS.SET_MODAL](state, isOpen: boolean) {
        state.isModaleOpen = isOpen;
    },
    [PREAVIS.SET_LOADING_LIST](state, loading: boolean) {
        state.isLoadingList = loading;
    },
    [PREAVIS.SET_SUBMITTING](state, submitting: boolean) {
        state.isSubmitting = submitting;
    },
    [PREAVIS.SET_ERROR](state, error: string | null) {
        state.error = error;
    },
    [PREAVIS.SET_LIST](state, items: PreavisInterventionDTO[]) {
        state.items = items ?? [];
    },
    [PREAVIS.ADD_ITEM](state, item: PreavisInterventionDTO) {
        state.items = [item, ...state.items.filter(i => i.id !== item.id)];
    },
    [PREAVIS.UPDATE_ITEM](state, item: PreavisInterventionDTO) {
        state.items = state.items.map(i => (i.id === item.id ? item : i));
    },
    [PREAVIS.REMOVE_ITEM](state, id: number) {
        state.items = state.items.filter(i => i.id !== id);
    },
    [PREAVIS.SET_FILTERS](state, payload: { siteIds?: number | number[]; equipementIds?: number | number[] }) {
        const siteIds = Array.isArray(payload?.siteIds)
            ? payload?.siteIds
            : payload?.siteIds != null
            ? [payload.siteIds]
            : undefined;
        const equipementIds = Array.isArray(payload?.equipementIds)
            ? payload?.equipementIds
            : payload?.equipementIds != null
            ? [payload.equipementIds as number]
            : undefined;

        state.currentSiteId = siteIds && siteIds.length ? siteIds[0] : undefined;
        state.currentEquipementId = equipementIds && equipementIds.length ? equipementIds[0] : undefined;
    },
    [PREAVIS.SET_SELECTED_ID](state, id: number | null) {
        state.selectedItemId = id ?? null;
    },
    [PREAVIS.SET_SORT](state, payload: { sortData: string; sortStatus: SortType }) {
        state.tableHeader.forEach(headerItem => {
            if (headerItem.sortStatus !== SortType.INACTIVE) {
                headerItem.sortStatus =
                    headerItem.sortData === payload.sortData ? payload.sortStatus : SortType.NONE;
            }
        });
    },
    [PREAVIS.RESET](state) {
        Object.assign(state, getInitialState());
    },
    [PREAVIS.SET_CREATE_DIRECT](state, payload: CreateDirectPayload | null) {
        state.createDirect = payload;
    },
    [PREAVIS.SET_PREAVIS_SITE](state, site: Site | undefined) {
        state.preavisSite = site;
    },
};
